import React from 'react';
import { formatMessage } from '../../../translations/format-message';
import OperatorHorizontalView from './../views/operator-horizontal-view';
import OperatorVerticalView from './../views/operator-vertical-view';

type InfoField = {
  labelKey: string;
  value: string | number | null | undefined;
  colWidth: number;
};

type OperatorAssignModeContentProps = {
  infoFields: InfoField[];
  trayHistory: string[];
  operatorResponseViewType: number;
  viewProps: any;
};

const OperatorAssignModeContent = ({
  infoFields,
  trayHistory,
  operatorResponseViewType,
  viewProps,
}: OperatorAssignModeContentProps) => {
  return (
    <div className="card tray-data opertor-dummy">
      <div className="operator-assign">
        <div>
          <div className="row g-1 tray-data-header justify-space-between p-0 mb-1">
            {infoFields.map(({ labelKey, value, colWidth }, index) => (
              <div
                className={`katashiki-width col-${colWidth}`}
                key={index}
                title={String(value ?? '')}
              >
                <p className="small text-muted">{formatMessage(labelKey)}</p>
                <p className="text-dark kisu-table ">{value || '-'}</p>
              </div>
            ))}
          </div>
          {trayHistory.length > 0 ? (
            operatorResponseViewType === 1 ? (
              <OperatorHorizontalView {...viewProps} />
            ) : (
              <OperatorVerticalView {...viewProps} />
            )
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OperatorAssignModeContent;
